export const FSHADER_END_CHUNK = "#ifdef CLEARCOAT\n" +
    "gl_FragColor.rgb = combineColorCC();\n" +
    "#else\n" +
    "gl_FragColor.rgb = combineColor();\n" +
    "#endif\n" +

    "gl_FragColor.rgb += getEmission();\n" +
    "gl_FragColor.rgb = addFog(gl_FragColor.rgb);\n" +

    "#ifndef HDR\n" +
    "gl_FragColor.rgb = toneMap(gl_FragColor.rgb);\n" +
    "gl_FragColor.rgb = gammaCorrectOutput(gl_FragColor.rgb);\n" +
    "#endif\n";